import { Modal, Button, Form, InputGroup, Row, Col } from 'react-bootstrap';

import Select from 'react-select';

import { selectCustomStyle } from '@/config/model';

import { Item, ITEMFIELDS, ITEMCLASSTYPE, Company } from '@/types';
import {
  CATALOGUE_TYPE,
  FITTING_TYPE,
  useItemUpdateModal,
} from '@/features/items';

type ItemCatalogueEditModalProps = {
  show: boolean;
  selectedItem: Item;
  activeCompanies: Company[];
  handleClose: () => void;
  showItemProperties: () => void;
};

/**
 * update item definition
 * @returns
 */
const ItemCatalogueEditModal = ({
  show,
  selectedItem,
  activeCompanies,
  handleClose,
  showItemProperties,
}: ItemCatalogueEditModalProps) => {
  const { id, properties } = selectedItem;
  const { companiesInUse, companyOptions, payload, ...handlers } =
    useItemUpdateModal(selectedItem, activeCompanies, handleClose);

  return (
    <Modal as={Modal.Dialog} centered show={show} onHide={handleClose}>
      <Modal.Header>
        <Modal.Title className="h6">Edit Item</Modal.Title>
        <Button variant="close" aria-label="Close" onClick={handleClose} />
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handlers.handleSubmit}>
          <Form.Group className="mb-3">
            <Form.Label>Item ID</Form.Label>
            <Form.Control size="sm" disabled readOnly value={id} />
          </Form.Group>
          {/* == Description == */}
          <Form.Group className="mb-3">
            <Form.Label>Description</Form.Label>
            <Form.Control
              value={payload.description || ''}
              name="description"
              size="sm"
              onChange={handlers.handleInputChange}
            />
          </Form.Group>
          {/* == Item Icon Upload - 2025/03/24 == */}
          <Row className="mb-3">
            <Form.Group controlId="svg_file_select">
              <Form.Label>Item Icon(.svg only)</Form.Label>
              <InputGroup>
                <Form.Control
                  type="file"
                  accept=".svg"
                  size="sm"
                  onChange={handlers.handleFileSelected}
                />
                <Button
                  type="button"
                  variant="success"
                  size="sm"
                  onClick={handlers.handleSVGUpload}
                >
                  Upload
                </Button>
              </InputGroup>
            </Form.Group>
          </Row>
          {/* == Item Classifcation */}
          <Form.Group className="mb-3">
            <Form.Label>
              Item Classification(if Customized for company)
            </Form.Label>
            <Form.Select
              value={payload.classification_type || ITEMCLASSTYPE.S}
              name={ITEMFIELDS.CL}
              size="sm"
              onChange={handlers.handleSelectChange}
            >
              <option value={ITEMCLASSTYPE.S}>Standard</option>
              <option value={ITEMCLASSTYPE.C}>Custom</option>
            </Form.Select>
          </Form.Group>
          {/* == Company selection == */}
          {payload.classification_type == ITEMCLASSTYPE.C && (
            <Select
              isMulti
              placeholder="Select a company..."
              name={ITEMFIELDS.CO}
              defaultValue={companiesInUse}
              options={companyOptions}
              classNamePrefix="select"
              styles={selectCustomStyle}
              onChange={handlers.handleCompanySelect}
            />
          )}
          {/* ===== one row three fields to save vertical space @2025/05/16 */}
          <Row className="mb-4 mt-4">
            {/* === TYPE selection === */}
            <Form.Group as={Col}>
              <Form.Label>Type</Form.Label>
              <Form.Select
                value={payload.type || ''}
                name="type"
                size="sm"
                onChange={handlers.handleSelectChange}
              >
                {Object.values(CATALOGUE_TYPE).map((option) => (
                  <option value={option} key={option}>
                    {option}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
            <Form.Group as={Col}>
              <Form.Label>Category</Form.Label>
              <Form.Select
                value={payload.category || ''}
                name="category"
                size="sm"
                onChange={handlers.handleSelectChange}
              >
                {Object.values(FITTING_TYPE).map((option) => (
                  <option value={option} key={option}>
                    {option}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
            {/* == Item Visibility == */}
            <Form.Group as={Col}>
              <Form.Label>Visible to UI</Form.Label>
              <Form.Select
                value={`${payload.ui_visible}`}
                name="ui_visible"
                size="sm"
                onChange={handlers.handleSelectChange}
              >
                <option value="true">True(show)</option>
                <option value="false">False(hidden)</option>
              </Form.Select>
            </Form.Group>
          </Row>
          {/* === properties == */}
          <div
            className="d-grid p-2 border"
            style={{
              gridTemplateColumns: '1fr 1fr',
              gap: '8px 64px',
              padding: 4,
              fontSize: '14px',
            }}
          >
            {properties.map((property) => {
              const key = 'prop:' + property.name;

              return (
                <Form.Group
                  key={key}
                  className="d-flex justify-content-between"
                >
                  <label htmlFor={key}>{property.label}</label>
                  <Form.Check
                    name={property.name}
                    id={key}
                    onChange={handlers.handleCheckbox}
                    defaultChecked
                  />
                </Form.Group>
              );
            })}
          </div>
          <div className="d-flex justify-content-between mt-4">
            <Button onClick={showItemProperties} variant="secondary">
              Show properties of item
            </Button>
            <div className="d-flex gap-3">
              <Button variant="light" onClick={handleClose}>
                Cancel
              </Button>
              <Button variant="secondary" type="submit">
                Save
              </Button>
              <Button variant="danger" onClick={handlers.handleItemDelete}>
                Delete
              </Button>
            </div>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default ItemCatalogueEditModal;
